__webpack_require__.p = "/frontendmentor-challenges/rest-countries-api-with-color-theme-switcher-master/public/";